<template>
    <button class="restartButton" @click="callApi">Restart</button>

    <div class="ErrorMessage" v-if="errorMsg">
      <p>{{ errorMsg }}</p>
    </div>
</template>

<script>
export default {
  data() {
    return {
      errorMsg : "",
    };
  },
  mounted() {
    this.sendBeacon();
  },
  methods: {
      //make POST api call with a body
      async callApi() { 
          try {
            const response = await fetch("https://IconicsWebApi.cjc.dk:8443/Reboot", {
              method: 'GET',
              headers: {
                'Content-Type' : 'application/json'
              },
            });
            if (response.ok) {
              console.log(await response.text());
              return response;
            } else {
              this.errorMsg = "Error: " + response.status + " " + response.statusText;
              return Promise.reject(response);
            }
          } catch (error) {
            console.error('API call error:', error);
          }
        },
        //Test Connection
        async sendBeacon() { 
          try {
            const response = await fetch("https://IconicsWebApi.cjc.dk:8443/Echo", {
              method: 'POST',
              headers: {
                'Content-Type' : 'application/json'
              },
            });
            if (response.ok) {
              console.log(await response.text());
              return response;
            } else {
              this.errorMsg = "Error: " + response.status + " " + response.statusText;
              return Promise.reject(response);
            }
          } catch (error) {
            console.error('API call error:', error);
          }
        }
    }
};
</script>

<style>
  .restartButton {
    width: 400px;
    height: 400px;
    border-radius: 200px;
    color: white;
    background-color:#880015;
    font-size: 50px;
  }
  .restartButton:hover {
    background-color:#BF001E;
  }
  .ErrorMessage {
    color: red;
    font-size: 30px;
  }
</style>
  